<template>
  <a
      @click="login"
      class="btn blue btn_big no-drag pointer"
  >
    {{ $t('account.login') }}
  </a>
</template>
<script>
  export default {
    name: 'LoginButton',
    methods:{
      login() {
        this.$emit('login');
      }
    }
  }
</script>